import { useMediaQuery as useMuiMediaQuery, useTheme as useTheme5 } from "@mui/system";
import { BaseThemeType } from "./BaseTheme";

export const useMediaQuery = useMuiMediaQuery;
export const useTheme = useTheme5<BaseThemeType>